import { BADGE_CONFIGS, STROLLERS_GUIDE_SECTION_HASHTAGS } from "@/mk2/components/Badge";
import { STROLLEROPEDIA_NEW_ARTICLES } from "@/mk/autogenerated/translations/ArticlesOfSections.constants.ef15754bb4769cbc569544ce779f7a67";

export const ARTICLES_OF_SECTIONS_MENU_SECTION_FILTER = "articles-of-sections-menu-section-filter";

export const STROLLERS_GUIDE_SECTION_RECENT = "recent" as const;

export const STROLLERS_GUIDE_SECTIONS_CONFIG = {
    [STROLLERS_GUIDE_SECTION_RECENT]: {
        hashtag: null,
        label: STROLLEROPEDIA_NEW_ARTICLES,
        icon: null,
        sectionSlug: STROLLERS_GUIDE_SECTION_RECENT,
    },
    [BADGE_CONFIGS.BuyingGuides.sectionSlug]: {
        hashtag: STROLLERS_GUIDE_SECTION_HASHTAGS.BuyingGuides,
        ...BADGE_CONFIGS.BuyingGuides,
    },
    [BADGE_CONFIGS.RedactionReview.sectionSlug]: {
        hashtag: STROLLERS_GUIDE_SECTION_HASHTAGS.RedactionReview,
        ...BADGE_CONFIGS.RedactionReview,
    },
    [BADGE_CONFIGS.HowTo.sectionSlug]: {
        hashtag: STROLLERS_GUIDE_SECTION_HASHTAGS.HowTo,
        ...BADGE_CONFIGS.HowTo,
    },
    [BADGE_CONFIGS.ExpertTips.sectionSlug]: {
        hashtag: STROLLERS_GUIDE_SECTION_HASHTAGS.ExpertTips,
        ...BADGE_CONFIGS.ExpertTips,
    },
    [BADGE_CONFIGS.Accessories.sectionSlug]: {
        hashtag: STROLLERS_GUIDE_SECTION_HASHTAGS.Accessories,
        ...BADGE_CONFIGS.Accessories,
    },
    [BADGE_CONFIGS.News.sectionSlug]: {
        hashtag: STROLLERS_GUIDE_SECTION_HASHTAGS.News,
        ...BADGE_CONFIGS.News,
    },
};
